import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { keepAlive: true }
  },
  {
    path: '/goin',
    name: 'goin',
    component: () => import('../views/GoinView.vue')
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('../views/ProductsView.vue')
  },
  {
    path: '/productDetail/:id',
    name: 'productDetail',
    component: () => import('../views/ProductDetailView.vue')
  },
  {
    path: '/cases',
    name: 'cases',
    component: () => import('../views/CaseView.vue')
  },
  {
    path: '/caseDetail/:id',
    name: 'caseDetail',
    component: () => import('../views/CaseDetailView.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/NewsView.vue')
  },
  {
    path: '/newsDetail/:id',
    name: 'newsDetail',
    component: () => import('../views/NewDetailView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  },
  {
    path: '/technology',
    name: 'technology',
    component: () => import('../views/TechnologyView.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,

  // ----------------------------------------------
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})


export default router